import { useStore } from "@/context/headerContext";
import { OverflowTooltip } from "ui-components-library";
import { TitleText, Action} from "./TitleV2.styles"

export interface TitleBlockProps {
    title?: string;
    actions?: React.ReactNode;
  }
  
  
  const Title = ({ title, actions }: TitleBlockProps) => {
    const [data] = useStore((store) => store);
  
    return (
  <>
        <TitleText>
          <OverflowTooltip>{title || data.title}</OverflowTooltip>
        </TitleText>
        <Action>{actions || data.actions}</Action>
   </>
    );
  };

  export default Title